import http from "../../http-common";

class EmployeeContractorService {
    get(data) {
        return http.post("/admin/reports/EmployeeOrContractor", data);
    }
}
export default new EmployeeContractorService();